var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 100,
    viewBox: "0 0 152 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3",
    "data-name": "Rect\\xE1ngulo 3",
    width: 21.47,
    height: 21.47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4",
    "data-name": "Rect\\xE1ngulo 4",
    width: 21.471,
    height: 21.47,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(-884 -500)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6",
    "data-name": "Rect\\xE1ngulo 6",
    width: 152,
    height: 100,
    rx: 15,
    transform: "translate(884 500)",
    fill: "#e8102d",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10",
    transform: "translate(37.79 -3.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M105.71,134.649H59.7a7.7,7.7,0,0,1-7.7-7.7V122H39.848a1.912,1.912,0,1,1,0-3.825H53.914a1.913,1.913,0,0,1,1.912,1.912v6.87a3.875,3.875,0,0,0,3.87,3.87H105.71a3.875,3.875,0,0,0,3.87-3.87v-28.9a3.875,3.875,0,0,0-3.87-3.87H59.7a3.875,3.875,0,0,0-3.87,3.87,1.912,1.912,0,0,1-3.825,0,7.7,7.7,0,0,1,7.7-7.7H105.71a7.7,7.7,0,0,1,7.7,7.7v28.9a7.7,7.7,0,0,1-7.7,7.7",
    transform: "translate(848.365 441.337)",
    fill: "#e8102d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M131.866,127.521a8.153,8.153,0,0,1-5.783-2.392l-15.423-15.423a1.912,1.912,0,0,1,2.7-2.7l15.423,15.423a4.359,4.359,0,0,0,6.157,0l23.4-23.4a1.912,1.912,0,0,1,2.7,2.7l-23.395,23.4a8.153,8.153,0,0,1-5.783,2.392",
    transform: "translate(799.204 435.808)",
    fill: "#e8102d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(939.334 551.926)",
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M223.876,175.31a1.907,1.907,0,0,1-1.352-.56L204.878,157.1a1.913,1.913,0,0,1,2.7-2.7l17.646,17.646a1.912,1.912,0,0,1-1.352,3.265",
    transform: "translate(-204.318 -153.839)",
    fill: "#e8102d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9",
    transform: "translate(901.334 551.926)",
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M87.01,175.31a1.912,1.912,0,0,1-1.352-3.265L103.3,154.4a1.913,1.913,0,0,1,2.7,2.7L88.363,174.75a1.907,1.907,0,0,1-1.352.56",
    transform: "translate(-85.098 -153.839)",
    fill: "#e8102d"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M30.138,118.437H15.331a1.912,1.912,0,0,1,0-3.825H30.138a1.912,1.912,0,0,1,0,3.825",
    transform: "translate(865.068 424.811)",
    fill: "#e8102d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M31.895,151.469H1.912a1.912,1.912,0,0,1,0-3.825H31.895a1.912,1.912,0,0,1,0,3.825",
    transform: "translate(874.21 402.307)",
    fill: "#e8102d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M25.943,207.727H15.331a1.912,1.912,0,0,1,0-3.825H25.943a1.912,1.912,0,0,1,0,3.825",
    transform: "translate(865.068 363.981)",
    fill: "#e8102d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.941baa2ab247dd3d83bc3e816eeef289.svg";
export { ForwardRef as ReactComponent };